<template>
  <div class="d-flex flex-column account-info">
    <Description class="mb-5 d-flex flex-column" />
  </div>
</template>

<script>
import Description from '@/views/account/sidebarInfo/components/Description';

export default {
  name: 'AccountInfoProfile',
  components: {
    Description,
  },
};
</script>
